window.location.replace(`/${process.env.REACT_APP_NAME}/signin`)

// TODO: refactor this screen to replace the Login with Signin when `login` type screen is developed by MAF
//       remember to updated JSON manifest in DevOps-IL-WebInfra-Developer-Env repo
